import {post, get, patch} from '@/lib/axios';

const certificate = {
    async download_annual_certificate(type, cert_id) {
        return get(`/certificate/annual/${type}/${cert_id}`);
    },
};

export {certificate as default};